import BaseService from './BaseService';
import { LIMIT_AUTOCOMPLETE_DEFAULT } from '@/helpers/Constants';
import { FormAutoCompleteData } from './FormStructure';

export default class AutoCompleteService extends BaseService {
    public async getAutoCompleteData(formId: number, questionId: number, searchString: string): Promise<FormAutoCompleteData[]> {
        try {
            let url = `forms/${formId}/questions/${questionId}/autocomplete-data?limit=${LIMIT_AUTOCOMPLETE_DEFAULT}`;
            if (searchString.length > 0) {
                url += `&search=${searchString}`;
            }
            const response = await this._get<FormAutoCompleteData[]>(decodeURIComponent(url));
            return response;
        } catch (error) {
            console.error("It's not possible load AutoComplete options", error);
            return [];
        }
    }
}
